import messages from '../../../locale/messages';
import { inputTextLimit , inputDescLimit  } from '../../../helpers/FieldRestriction';

const validate = values => {
    const errors = {};
    if (values.homeSectionTitle1) {
        let errorHomeSectionTitle = [];
        if (values?.homeSectionTitle1?.map((item, index) => {
            const homeSectionError = {}
            if (!item?.value || item?.value.toString().trim() === '') {
                homeSectionError.value = messages.required;
                errorHomeSectionTitle[index] = homeSectionError;
            } else if (item?.value?.length > inputTextLimit) {
                homeSectionError.value = messages.inputTextLimitError;
                errorHomeSectionTitle[index] = homeSectionError;
            }
            if (!item?.description || item?.description?.toString().trim() === '') {
                homeSectionError.description = messages.required;
                errorHomeSectionTitle[index] = homeSectionError;
            } else if (item?.description?.length > inputDescLimit ) {
                homeSectionError.description = messages.inputDescLimitError;
                errorHomeSectionTitle[index] = homeSectionError;
            }

            if(!item?.language || item?.language.toString().trim() === '') {
                homeSectionError.language = messages.required;
                errorHomeSectionTitle[index] = homeSectionError;
            }
        }));
        if (errorHomeSectionTitle?.length > 0) errors.homeSectionTitle1 = errorHomeSectionTitle;
    }
    return errors;
};

export default validate;